import type { editor } from "monaco-editor";

const baseOptions: editor.IStandaloneEditorConstructionOptions = {
  selectOnLineNumbers: true,
  automaticLayout: true,
  minimap: { enabled: false },
  insertSpaces: true,
  detectIndentation: false,
  autoIndent: "full",
  formatOnPaste: true,
  formatOnType: true,
  bracketPairColorization: { enabled: true },
  autoClosingBrackets: "always",
  autoClosingQuotes: "always",
  guides: { bracketPairs: true, indentation: true },
  hover: {
    enabled: true,
    delay: 300,
    sticky: true
  }
};

export const typescriptEditorOptions: editor.IStandaloneEditorConstructionOptions = {
  ...baseOptions,
  tabSize: 2
};

export const csharpEditorOptions: editor.IStandaloneEditorConstructionOptions = {
  ...baseOptions,
  tabSize: 4
};

export const pythonEditorOptions: editor.IStandaloneEditorConstructionOptions = {
  ...baseOptions,
  tabSize: 4
};

export const javaEditorOptions: editor.IStandaloneEditorConstructionOptions = {
  ...baseOptions,
  tabSize: 4
};

// Go is formatted by gofmt with hard tabs, so the editor indents with tabs (not spaces) to match.
export const goEditorOptions: editor.IStandaloneEditorConstructionOptions = {
  ...baseOptions,
  insertSpaces: false,
  tabSize: 4
};

// Rust is formatted by rustfmt with 4 spaces.
export const rustEditorOptions: editor.IStandaloneEditorConstructionOptions = {
  ...baseOptions,
  tabSize: 4
};
